class FAQAccordion {
  constructor() {
    this.init();
  }

  init() {
    const faqButtons = document.querySelectorAll('[data-faq-toggle]');
    
    faqButtons.forEach(button => {
      button.addEventListener('click', this.handleToggle.bind(this));
      
      // Set initial ARIA attributes
      const answer = button.nextElementSibling;
      if (answer) {
        answer.setAttribute('aria-hidden', 'true');
      }
    });
  }

  handleToggle(event) {
    const button = event.currentTarget;
    const answer = button.nextElementSibling;
    const isExpanded = button.getAttribute('aria-expanded') === 'true';
    
    // Close all other FAQ items
    this.closeAllFAQs(button);
    
    // Toggle current FAQ item
    if (!isExpanded) {
      this.openFAQ(button, answer);
    } else {
      this.closeFAQ(button, answer);
    }
  }

  openFAQ(button, answer) {
    button.setAttribute('aria-expanded', 'true');
    answer.setAttribute('aria-hidden', 'false');
    answer.style.maxHeight = answer.scrollHeight + 'px';
  }

  closeFAQ(button, answer) {
    button.setAttribute('aria-expanded', 'false');
    answer.setAttribute('aria-hidden', 'true');
    answer.style.maxHeight = '0px';
  }

  closeAllFAQs(currentButton) {
    const allButtons = document.querySelectorAll('[data-faq-toggle]');
    const allAnswers = document.querySelectorAll('.wt-faq__answer');
    
    allButtons.forEach(btn => {
      if (btn !== currentButton) {
        const answer = btn.nextElementSibling;
        this.closeFAQ(btn, answer);
      }
    });
  }
}

// Initialize FAQ accordion when DOM is loaded
document.addEventListener('DOMContentLoaded', () => {
  new FAQAccordion();
});

// Re-initialize if content is dynamically loaded
document.addEventListener('shopify:section:load', () => {
  new FAQAccordion();
});
